import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { change_password } from '../api/auth_api';

const ChangePassword = () => {
    const location = useLocation();
    const email = location.state?.email;
    const fromVerification = location.state?.fromVerification;
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!fromVerification || !email) {
            navigate('/forgot_password');
        }
    }, [fromVerification, email, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        if (newPassword !== confirmPassword) {
            setError('הסיסמאות אינן תואמות');
            return;
        }

        if (newPassword.length < 4 || newPassword.length > 16) {
            setError('הסיסמה חייבת להכיל בין 4 ל־16 תווים');
            return;
        }

        try {
            setLoading(true);
            const response = await change_password(email, newPassword);
            navigate(`/beneficiaries`);
            setMessage(response.message || 'הסיסמה שונתה בהצלחה!');
            setNewPassword('');
            setConfirmPassword('');

        } catch (err) {
            const serverMessage = err.response?.data?.message;
            const fallbackMessage = 'קרתה שגיאה בעת שינוי הסיסמה.';
            setError(serverMessage || fallbackMessage);
            setNewPassword('');
            setConfirmPassword('');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <form onSubmit={handleSubmit} className="login-form">
                <h2 className="login-title">שינוי סיסמה</h2>
                <p>נא הזן סיסמה חדשה ואשר אותה</p>

                <div className="form-group">
                    <label>סיסמה חדשה</label>
                    <input type="password" name="newPassword" value={newPassword} onChange={(e) =>
                        setNewPassword(e.target.value)} minLength={4} maxLength={16} required
                    />
                </div>

                <div className="form-group">
                    <label>אישור סיסמה</label>
                    <input type="password" name="confirmPassword" value={confirmPassword} onChange={(e) =>
                        setConfirmPassword(e.target.value)} minLength={4} maxLength={16} required
                    />

                </div>

                <button type="submit" className="connect-btn" disabled={loading}>
                    {loading ? 'שולח...' : 'שנה סיסמה'}
                </button>

                {message && <p className="success-message">{message}</p>}
                {error && <p className="error-message">{error}</p>}
            </form>
        </div>
    );
};

export default ChangePassword;
